import React from 'react';
import { BookOpen, Film, Sparkles, Target } from 'lucide-react';

const WhoThisIsForSection = () => {
  const audiences = [
    {
      icon: BookOpen,
      title: "Authors Who Want Serious Book Promotion",
      description: "You've written a book worth seeing. You want marketing materials that match the quality of your story, not generic stock footage slideshows."
    },
    {
      icon: Film,
      title: "Authors Curious About Adaptation",
      description: "You've wondered what your book would look like on screen. Visual development materials give you something real to show, not just a pitch deck."
    },
    {
      icon: Target,
      title: "Authors Building an Audience",
      description: "You understand that visual content drives engagement. Book trailers, scene reels, and design imagery help you stand out in a crowded market."
    },
    {
      icon: Sparkles,
      title: "Authors Ready to Invest in Their Work",
      description: "You see your book as a business. Professional visual assets are an investment in marketing reach and long-term adaptation potential."
    }
  ];

  return (
    <section className="py-20 px-4 bg-[#061018] relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="abstract-blob animate-float" style={{ 
          top: '30%', 
          left: '5%', 
          width: '400px', 
          height: '400px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.2), transparent 70%)',
          filter: 'blur(80px)'
        }}></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <p className="text-sm text-[#FF6500] uppercase tracking-widest mb-3">
            Is This Right For You?
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Who This Is <span className="text-[#FF6500]">For</span>
          </h2>
          <p className="text-lg text-[#aaa] max-w-3xl mx-auto">
            Built for book marketing. Ready for adaptation conversations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {audiences.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={index}
                className="bg-[#0a1525] border border-[#152840] rounded-xl p-6 hover:border-[#FF6500]/30 transition-all duration-300 group"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#FF6500]/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#FF6500]/20 transition-colors">
                    <Icon className="w-6 h-6 text-[#FF6500]" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                    <p className="text-[#aaa] text-sm leading-relaxed">{item.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Dual Purpose Value Prop */}
        <div className="mt-12 bg-gradient-to-r from-[#FF6500]/10 to-transparent border border-[#FF6500]/20 rounded-xl p-8 text-center">
          <p className="text-xl text-white font-medium mb-2">
            "We help authors bring their stories to life visually"
          </p>
          <p className="text-[#aaa]">
            With cinematic trailers, design bibles, and development materials built for both marketing and adaptation readiness.
          </p>
          <p className="text-sm text-[#666] mt-4 italic">
            Built for authors who are serious about their story's visual future.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsForSection;
